import { useMutation } from "@tanstack/react-query"

/** Was der Knopf vom Anruf wissen muss — passt auf KI-Telefon-`Call` und auf den Live-Banner. */
export type UebernehmenAnruf = {
  call_id: string
  status: string
  uebernahme_angefordert_at?: string | null
  uebernahme_ergebnis?: "verbunden" | "keine_antwort" | "geht_nicht" | null
}

const UEBERNAHME_TEXT: Record<string, string> = {
  verbunden: "Büro hat übernommen",
  keine_antwort: "Übernahme: niemand hat abgenommen",
  geht_nicht: "Übernahme nicht möglich",
}

/**
 * voice#40 (Marlene, 12.10.2026): „einen einkommenden Anruf auch direkt
 * annehmen, auch wenn die KI schon abgenommen hat". Nur an laufenden
 * Gesprächen: ein Klick, die KI sagt „Einen Moment, ich verbinde Sie“ und das
 * Bürotelefon klingelt. Nimmt niemand ab, macht die KI weiter.
 */
export function UebernehmenKnopf({ call, onChange }: { call: UebernehmenAnruf; onChange?: () => void }) {
  const uebernehmen = useMutation({
    mutationFn: async () => {
      const res = await fetch(`/admin/ki-telefon/api/call/${encodeURIComponent(call.call_id)}/uebernehmen`, {
        method: "POST", credentials: "include",
      })
      const j = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(j.error || `HTTP ${res.status}`)
      return j
    },
    onSettled: () => onChange?.(),
  })
  if (call.uebernahme_ergebnis) {
    return <div className="text-[11px] text-muted-foreground mt-1">{UEBERNAHME_TEXT[call.uebernahme_ergebnis] || "Übernahme beendet"}</div>
  }
  if (call.status !== "in_progress") return null
  if (call.uebernahme_angefordert_at || uebernehmen.isSuccess) {
    return <div className="text-[11px] text-primary mt-1">Wird verbunden, Ihr Telefon klingelt gleich …</div>
  }
  return (
    <div className="mt-1" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="pp-btn pp-btn-sm" disabled={uebernehmen.isPending}
        title="Die KI kündigt die Verbindung an, dann klingelt das Bürotelefon. Nimmt niemand ab, macht die KI weiter."
        onClick={() => uebernehmen.mutate()}>
        {uebernehmen.isPending ? "…" : "Übernehmen"}
      </button>
      {uebernehmen.isError && <div className="text-[11px] text-destructive mt-1">{(uebernehmen.error as Error).message}</div>}
    </div>
  )
}
